import {
  LOAD_POSITION_LIST,
  LOAD_POSITION_LIST_SUCCESS,
  LOAD_POSITION_LIST_ERROR,
  ADD_POSITION,
  ADD_POSITION_SUCCESS,
  ADD_POSITION_ERROR,
  UPDATE_POSITION,
  UPDATE_POSITION_SUCCESS,
  UPDATE_POSITION_ERROR,
  DELETE_POSITION,
  DELETE_POSITION_SUCCESS,
  DELETE_POSITION_ERROR,
  RESET_POSITION_LIST,
} from '../type';
import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

export const initialState = {
  loadingStatus: {
    positionListLoading: false,
    addPositionLoading: false,
    updatePositionLoading: false,
    deletePositionLoading: false,
  },
  error: '',
  positionList: [],
};

const positionReducer = handleActions(
  new Map([
    [
      LOAD_POSITION_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            positionListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_POSITION_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            positionListLoading: { $set: false },
          },
          positionList: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_POSITION_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            positionListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    //Reset position list
    [
      RESET_POSITION_LIST,
      (state, action) => {
        return update(state, {
          positionList: {
            $set: [],
          },
        });
      },
    ],
    [
      ADD_POSITION,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            addPositionLoading: { $set: true },
          },
        });
      },
    ],
    [
      ADD_POSITION_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            addPositionLoading: { $set: false },
          },
          updatedPosition: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      ADD_POSITION_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            addPositionLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    [
      UPDATE_POSITION,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            updatePositionLoading: { $set: true },
          },
        });
      },
    ],
    [
      UPDATE_POSITION_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            updatePositionLoading: { $set: false },
          },
          updatedPosition: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      UPDATE_POSITION_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            updatePositionLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    [
      DELETE_POSITION,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            deletePositionLoading: { $set: true },
          },
        });
      },
    ],
    [
      DELETE_POSITION_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            deletePositionLoading: { $set: false },
          },
        });
      },
    ],
    [
      DELETE_POSITION_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            deletePositionLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
  ]),
  initialState,
);
export default positionReducer;
